import { computed } from "vue";
import { useMediaQuery } from "@vueuse/core";
export var EBreakpoints = /* @__PURE__ */ ((EBreakpoints2) => {
  EBreakpoints2[EBreakpoints2["XS"] = 320] = "XS";
  EBreakpoints2[EBreakpoints2["SM"] = 640] = "SM";
  EBreakpoints2[EBreakpoints2["MD"] = 768] = "MD";
  EBreakpoints2[EBreakpoints2["LG"] = 1024] = "LG";
  EBreakpoints2[EBreakpoints2["XL"] = 1280] = "XL";
  EBreakpoints2[EBreakpoints2["XXL"] = 1920] = "XXL";
  EBreakpoints2[EBreakpoints2["XXXL"] = 2560] = "XXXL";
  return EBreakpoints2;
})(EBreakpoints || {});
const SSR_WIDTH = 400;
export default function useBreakpoint() {
  const isXS = useMediaQuery(`(max-width: ${640 /* SM */ - 1}px)`, { ssrWidth: SSR_WIDTH });
  const isSM = useMediaQuery(`(min-width: ${640 /* SM */}px) and (max-width: ${768 /* MD */ - 1}px)`, {
    ssrWidth: SSR_WIDTH
  });
  const isMD = useMediaQuery(`(min-width: ${768 /* MD */}px) and (max-width: ${1024 /* LG */ - 1}px)`, {
    ssrWidth: SSR_WIDTH
  });
  const isLG = useMediaQuery(`(min-width: ${1024 /* LG */}px) and (max-width: ${1280 /* XL */ - 1}px)`, {
    ssrWidth: SSR_WIDTH
  });
  const isXL = useMediaQuery(`(min-width: ${1280 /* XL */}px) and (max-width: ${1920 /* XXL */ - 1}px)`, {
    ssrWidth: SSR_WIDTH
  });
  const isXXL = useMediaQuery(`(min-width: ${1920 /* XXL */}px)`, { ssrWidth: SSR_WIDTH });
  const isMobile = computed(() => isXS.value || isSM.value);
  const isTablet = computed(() => isMD.value);
  const isDesktop = computed(() => isLG.value || isXL.value || isXXL.value);
  const viewPort = computed(() => {
    if (isMobile.value || isSM.value) return "MOBILE";
    if (isMD.value) return "TABLET";
    return "DESKTOP";
  });
  const breakpoint = computed(() => {
    if (isXS.value) return "XS";
    if (isSM.value) return "SM";
    if (isMD.value) return "MD";
    if (isLG.value) return "LG";
    if (isXL.value) return "XL";
    if (isXXL.value) return "XXL";
    return "XXXL";
  });
  return {
    isXS,
    isSM,
    isMD,
    isLG,
    isXL,
    isXXL,
    isMobile,
    isTablet,
    isDesktop,
    viewPort,
    breakpoint
  };
}
